import $ from 'jquery';
import hcSticky from 'hc-sticky';

$('.highlighted-event__wrapper').on('click', function (e) {
    if (e.offsetX < 0) {
        $(this).parent().toggleClass('highlighted-event--active');
    }
});

if ($('.highlighted-event').length) {
    document.addEventListener('DOMContentLoaded', function () {
        new hcSticky('.highlighted-event', {
            stickTo: 'body',
            top: $('#wpadminbar').length ? $('#wpadminbar').height() + 30 : 30,
            responsive: {
                765: {
                    disable: true,
                },
            },
        });
    });
}
